import React from "react";
import PropTypes from "prop-types";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import { BUTTON_THEME_BLACK_SMALL } from "components/v3/primary-button/themes";
import AnimatedText from "components/v3/animated-text/AnimatedText";
import styles from "./styles.module.scss";

const SUBSCRIBED_MESSAGE = "You are subscribed";
const UNSUBSCRIBED_MESSAGE = "You are unsubscribed";

class Newsletter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            subscribed: props.subscribed,
            messageText: props.subscribed ? SUBSCRIBED_MESSAGE : ""
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.subscribed === nextProps.subscribed) {
            return;
        }

        this.setState({
            subscribed: nextProps.subscribed,
            messageText: nextProps.subscribed ? SUBSCRIBED_MESSAGE : UNSUBSCRIBED_MESSAGE
        });
    }

    render() {
        const {
            title,
            listId: newsletterId,
            mainTout,
            description,
            onChange
        } = this.props;

        const {
            subscribed,
            messageText
        } = this.state;

        const newsletterText = mainTout || description;

        return (
            <div className={ styles.content }>
                <div className={ styles.title }>
                    { title }
                </div>
                <div className={ styles.summary }>
                    { newsletterText }
                </div>
                <PrimaryButton
                    theme={ BUTTON_THEME_BLACK_SMALL }
                    text={ subscribed ? "Unsubscribe" : "Subscribe" }
                    onClick={ onChange.bind(null, newsletterId, !subscribed) }
                    type="button"
                />
                <AnimatedText
                    textValue={ messageText }
                    baseClassName={ styles.fadeMessage }
                    animationClassName={ styles.statusChange }
                />
            </div>
        );
    }
}

Newsletter.propTypes = {
    title: PropTypes.string.isRequired,
    listId: PropTypes.string.isRequired,
    mainTout: PropTypes.string,
    description: PropTypes.string,
    subscribed: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
};

export default Newsletter;
